import { SettingsCategory } from '../enums'
import type { SettingsNavCategory } from '../types'

export const VALID_SETTINGS_CATEGORIES = new Set<SettingsNavCategory['id']>([
  SettingsCategory.ACCOUNT,
  SettingsCategory.WORKSPACE,
  SettingsCategory.PROJECT,
])
export const ACCOUNT_SETTINGS_SUBPAGES = new Set(['organizations'])
export const DEFAULT_SETTINGS_CATEGORY: SettingsNavCategory['id'] = SettingsCategory.ACCOUNT
export const DEFAULT_SETTINGS_SUBPAGE = 'general'
